import { render, staticRenderFns } from "./WidgetConfigFormV2.vue?vue&type=template&id=a13712be&scoped=true&"
import script from "./WidgetConfigFormV2.vue?vue&type=script&lang=ts&"
export * from "./WidgetConfigFormV2.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetConfigFormV2.vue?vue&type=style&index=0&id=a13712be&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13712be",
  null
  
)

export default component.exports